(function(){
  'use strict';
  document.addEventListener('click',function(event){
    var toggle=event.target.closest('[data-menu-toggle]');
    if(!toggle)return;
    var menu=document.getElementById('rc-mobile-nav');
    if(!menu)return;
    var open=toggle.getAttribute('aria-expanded')==='true';
    toggle.setAttribute('aria-expanded',String(!open));menu.hidden=open;
  });
  document.addEventListener('change',function(event){
    var input=event.target.closest('[data-variant-selector]');
    if(!input)return;
    var price=document.querySelector('[data-product-price]');
    if(price && input.selectedOptions[0])price.textContent=input.selectedOptions[0].dataset.price || price.textContent;
  });
})();
